import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import { Store } from '@ngrx/store';
import { Fare } from '../../modal';

import * as ActionFare from './action';

@Injectable()
export class FareEffects {
  constructor(private store: Store<RootStoreState.State>, private actions$: Actions) {}

  loadAction$ = createEffect(() => this.actions$
    .pipe(
      ofType<ActionFare.PostFareRequest>(ActionFare.POST_Fare),
      map(action => {return action.payload as any}),
      
    ));
  private handleError(error) {
    return of(new ActionFare.Error(error));
  }
}
